/* eslint-disable angular/document-service */
import { DEFAULT_CONSENT_MESSAGE } from '../../constants/signature-consent.constant';

class SignatureModalController {
  constructor($timeout, $window, $scope) {
    'ngInject';
    Object.assign(this, {$timeout, $window, $scope});
    this.sigMessage = '';
    this.title = 'Sign Below';
    this.loaded = false;
    this.eventsAttached = false;
    this.initData = '';
    this.fontSignatureDataUrl = '';
    this.wideSignature = true;
    this.fontSignature = false;
    this.consentChecked = false;
    this.resetSigEvent = () => { this.resetSignature() };
    this.keyDownEvent = (event) => this.keyDown({ keyDownData: { event, submit: this.submit.bind(this), accept: () => this.getSignature() } });
    this.$scope.$watch('$ctrl.fontSignature', () => { this.clearSig({clear: this.clear}) });
  }
  
  $onInit() {
    if (this.disablePad) this.fontSignature = true;
    if (!this.consentText) this.consentText = DEFAULT_CONSENT_MESSAGE;
  }
  
  $postLink() {
    if(this.label) this.title = `${this.title}: "${this.label}"`;
    this.$timeout( () => { this.showPad() }, 0);
  }

  $onDestroy() {
    this.$window.removeEventListener("orientationchange", this.resetSigEvent);
    this.$window.removeEventListener("keydown", this.keyDownEvent);
  }

  showPad() {
    
    const vh = Math.max(document.documentElement.clientHeight || 0, this.$window.innerHeight || 0);
    const maxHeight = vh - 150;
    const maxWidth = Math.ceil(angular.element('.modal-dialog ')[0].offsetWidth * 0.94);

    if ( this.aspect <= 1 ) {
      this.padWidth = maxWidth;
      this.padHeight = Math.ceil(maxWidth * this.aspect);
    }
    if (this.aspect > 1 || this.padHeight > maxHeight) {
      this.padHeight = maxHeight;
      this.padWidth = Math.ceil(maxHeight / this.aspect);
    }

    this.wideSignature = (this.padWidth >= this.padHeight);

    if (this.$window.orientation !== undefined) this.setMobileAlert();

    this.viewportWidth = Math.max(document.documentElement.clientWidth || 0, this.$window.viewportWidth || 0);

    this.eventsAttached || this.$window.addEventListener("orientationchange", this.resetSigEvent);
    this.eventsAttached || this.$window.addEventListener("keydown", this.keyDownEvent);
    this.eventsAttached = true;
    this.fontSignatureDataUrl = this.initData || '';
    this.loaded = true;
    this.$scope.$apply();
  }

  getSignature() {
    if (this.fontSignature) {
      return { dataUrl: this.fontSignatureDataUrl || '', isEmpty: !this.hasSignatureData };
    }
    return this.accept ? this.accept() : { dataUrl: '', isEmpty: true };
  }

  setMobileAlert() {
    const isMobilePortrait = this.$window.orientation % 180 === 0;
    this.sigMessage = ((isMobilePortrait && this.wideSignature) || (!isMobilePortrait && !this.wideSignature))
      ? 'Rotate device for larger signature pad.'
      : '';
  }

  resetSignature () {
    this.loaded = false;
    this.initData = '';
    this.fontSignatureDataUrl = '';
    this.consentChecked = false;
    this.clearSig();
    this.$scope.$apply();
    this.$timeout(() => { this.showPad() }, 500);
  }

  submit() {
    this.$timeout(() => {
      this.$scope.$apply();
      if (this.required && !this.hasSignatureData) return;
      if (this.requireConsentAgreement && !this.consentChecked) return;
      const result = this.getSignature();
      this.acceptSig({ accept: () => result });
    }, 0);
  }
}

export default {
  templateUrl: 'fe-control/modals/signature/signature.component.html',
  bindings:{
    'cancelModal': "&?",
    'aspect': '=?',
    'hasSignatureData': '=?',
    'fieldWidth': '=?',
    'color': '=?',
    'font': '=?',
    'label': '<?',
    'required': '<?',
    'requireConsentAgreement': '<?',
    'consentText': '<?',
    'disableKeyboard': '<?',
    'disablePad': '<?',
    'clearSig': '&?',
    'acceptSig': '&?',
    'keyDown': '&?',
  },
  controller: SignatureModalController
}
